module.exports = __webpack_public_path__ + "static/img-19-24bfd82a0684062fd9bb94e8d21e084f.jpeg";